<template>
    <div>
        <div v-if="errorLogin == null">
            <div class="seccion-titulo">
                {{ $t('secretaria_virtual', {nombreApp: $parent.getNombreApp}) }} 
            </div>   
            <div class="seccion-parrafo-nivel-1">
                {{ $t('bienv_secretariatramites', {nombreApp: $parent.getNombreApp}) }} 
            </div> 
            <div class="seccion-parrafo-nivel-2">
                {{ $t('bienv_tramites', {nombreApp: $parent.getNombreApp}) }} 
            </div>    
            <div class="seccion-subtitulo" id="contenidoPrincipal">
                {{ $t('bienv_puedeshacer') }}
            </div>   

            <div class="iconos-principal">
                <div class="icono-card" @click="$router.push('/diplomas')">
                    <div class="icono-bg p-col-2" style="font-size:8em">
                        <i class="fas fa-graduation-cap" aria-hidden="true"></i>
                    </div>
                    <div class="icono-title">
                        {{$parent.getTextoDiplomas}}
                    </div>
                    <div class="icono-content">
                        {{ $t('bienv_consultasolicita', {textoDiplomas: $parent.getTextoDiplomas}) }}
                    </div>
                </div>
                <!-- <div class="icono-card">
                </div>
                <div class="icono-card">
                </div>
                <div class="icono-card">
                </div> -->
            </div>   
        </div>
        <div v-if="errorLogin != null">
            <div class="msg-warn">
                <div class="msg-warn-title">{{ $t('err_acceso') }}</div>
            </div>
        </div>
        
    </div>   
</template>

<script>

import ServicioRest from "@/services/ServicioRest";
import store from "../store"

export default {
 data() {
    return {
      servicioRest: null,
      errorLogin: null,
    };
  },    
  created() {
    this.servicioRest = new ServicioRest();
    this.errorLogin =  null;

    // Accedemos al getter poniendo especificando el módulo / getter
    let token = store.getters["token/getToken"];
    this.servicioRest.login(token).then((response) => {
      if (response.status == 3){
        this.errorLogin = "El usuario o clave introducidos son incorrectos";
      } else if (response.status == 4){
        this.errorLogin = "Ha ocurrido un error, no se pueden validar los datos";
      } else{ //respuesta 0, ok
          //nada, todo ok
      }
     });
  },

}
</script>